import {base} from './base'

async function getListRole(param) {
  return base.get(`accounts/roles`, param, true, false)
}

async function getListEmployeeType() {
  return base.get(`common/employee-type`, {}, true, false)
}

async function getListUnit() {
  return base.get(`catalogs/units`, {}, true)
}

async function getListRegion() {
  return base.get(`catalogs/regions`, {}, true)
}

async function getListBrand() {
  return base.get(`catalogs/trademarks`, {}, true)
}

async function getListWarehouse() {
  return base.get(`catalogs/warehouses`, {}, true)
}

async function quickSearch(data) {
  return base.post('telesales/search', data)
}

async function registerFirebase(data) {
  return base.post('accounts/firebase-registration', data)
}

async function getDistributorInfo(param) {
  return base.get(`catalogs/distributors`, param, true)
}

async function updateDistributorInfo(param) {
  return base.put(`catalogs/distributors`, param, true)
}

async function getListCity(param) {
  return base.get(`catalogs/cities`, param, true)
}

async function getListSaleChannel() {
  return base.get(`catalogs/sale-channels`, {}, true)
}

export const commonService = {
  getListRole,
  getListEmployeeType,
  getListUnit,
  getListRegion,
  getListWarehouse,
  getListBrand,
  quickSearch,
  registerFirebase,
  getDistributorInfo,
  updateDistributorInfo,
  getListCity,
  getListSaleChannel
};
